import Vue from 'vue'
import Vuex from 'vuex'
import request from '@/request/http'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		UserToken: localStorage.getItem('UserToken'),
		UserInfo:''
	},
	mutations: {
		SET_USERTOKEN(state, value) {
			localStorage.setItem('UserToken', value)
			localStorage.setItem('key-expire', ((new Date()).valueOf() + (12*60*60*1000)));
			state.UserToken = value
		},
		SET_USERINFO(state, userInfo) {
			state.UserInfo = userInfo
		},
	},
	actions: {
		LOGIN({ commit }, userinfo) {
			return new Promise((resolve, reject) => {
				request({//获取token
					method: "post",
					url: "/pc/login",
					data: userinfo
				}).then(res => {
					commit('SET_USERTOKEN', res.data.data.token)
					resolve(res)
				}).catch(error => {
					reject(error)
				});
			})
		},
    MLOGIN({ commit }, userinfo) {
      return new Promise((resolve, reject) => {
        request({//获取token
          method: "post",
          url: "/wap/login",
          data: userinfo
        }).then(res => {
          commit('SET_USERTOKEN', res.data.data.token)
          resolve(res)
        }).catch(error => {
          reject(error)
        });
      })
    },
		GET_USERINFO({ commit }) {
            return new Promise((resolve, reject) => {
                request({
                    method: "post",
                    url: "/pc/user/my-detail",
                }).then(res => {
                    commit('SET_USERINFO', res.data.data);
					localStorage.setItem("UserInfo", JSON.stringify(res.data.data));
					localStorage.setItem('key-expire', ((new Date()).valueOf() + (12*60*60*1000)));
                    resolve(res);
                }).catch(error => {
                    reject(error);
                });
            })
        },
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js